<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{ $t('page.fault.fault_knowledge_base') }}</h4>
        </div>
        <div class="card-body">
          <div class="w-100">
            <div
              v-for="(a, index) in fault_knowledge_value"
              :key="index"
              :class="['row', index != 0 && 'mt-2', index != 0 && 'pt-4']"
              style="border-bottom: 1px dotted #f2f3f4"
            >
              <div class="col-3 p-2">
                <div>
                  <div>{{ $t('Fault Type') }}</div>
                  <div class="mt-2">
                    <p>{{ a.name }}</p>
                  </div>
                </div>
                <div class="mt-4">
                  <div>{{ $t('page.fault.correlative_measuring_points') }}</div>
                  <div class="mt-2">
                    <p>
                      <span
                        v-for="c in a.measurements"
                        :key="c"
                        class="badge bg-primary me-2"
                        >{{ measurementsText(c) }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-8">
                <div>{{ $t('page.fault.fault_description') }}</div>
                <div
                  class="mt-3"
                  style="
                    border: 1px solid #f2f3f4;
                    border-bottom: none;
                    padding: 10px;
                    padding-top: 0;
                    padding-bottom: 0;
                  "
                >
                  <div
                    class="row pt-2 pb-2"
                    style="
                      background: #f6f8fb;
                      border-bottom: 1px solid #f2f3f4;
                    "
                  >
                    <div class="col-3">{{ $t('page.fault.fault_symptoms') }}</div>
                    <div class="col-4">{{ $t('page.fault.fault_cause') }}</div>
                    <div class="col-5">{{ $t('page.fault.resolution') }}</div>
                  </div>
                  <div
                    v-for="(b, i) in a.description"
                    :key="i"
                    class="row pt-2 pb-2"
                    style="border-bottom: 1px solid #f2f3f4"
                  >
                    <div class="col-3">
                      <p>{{ b.manifest }}</p>
                    </div>
                    <div class="col-4">
                      <p>{{ b.cause }}</p>
                    </div>
                    <div class="col-5 position-relative">
                      <p>{{ b.solution }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update:fault_knowledge"],
  props: {
    fault_knowledge: {
      type: Array,
      default: () => {
        return [];
      },
    },
    measurements: {
      type: Array,
      default: () => {
        return [];
      },
    },
    attrDataList:{
        type:Object,
        default:()=>{
            return {}
        }
    }
  },
  setup() {},
  data() {
    return {
      editFlag: true,
      dataTypes: [],
      measure: "",
      fault_knowledge_value: [],
      props: { multiple: true, emitPath: false, label: "name", value: "key" },
      options: [
        {
          value: 1,
          label: "东南",
        },
      ],
      measurementList: [],
    };
  },
  components: {},
  watch: {

    fault_knowledge_value: {
      handler(newVal) {
        this.$emit("update:fault_knowledge", newVal);
      },
      deep: true,
    },
    fault_knowledge: {
      handler(newVal) {
        this.fault_knowledge_value = newVal;
      },
      deep: true,
    },
    measurements: {
      handler(newVal) {
        console.log(newVal);
        this.measurementList = newVal;
      },
      deep: true,

    },
  },
  methods: {
    measurementsText(text){
      var name=text
      this.measurements&&this.measurements.map(item=>{
        if(item.key==text){
          name=item.name
        }
      })
      return name
    },
    delDescription(index, i) {
      this.fault_knowledge_value[index].description.splice(i, 1);
      if (this.fault_knowledge_value[index].description.length == 0) {
        this.fault_knowledge_value.splice(index, 1);
      }
    },
    addDescription(index) {
      this.fault_knowledge_value[index].description.push({
        manifest: "",
        cause: "",
        solution: "",
      });
    },
    addFault() {
      this.fault_knowledge_value.push({
        name: "",
        measurements: [],
        description: [],
      });
    },
    delFault(index) {
      this.fault_knowledge_value.splice(index, 1);
    },
  },
  mounted() {
      console.log(this.attrDataList)
  },
};
</script>
<style lang="scss" scoped>
p {
  margin: 0;
}
</style>
